export const SET_PRESCRIPTIONS_TABLE_DATA = 'SET_PRESCRIPTIONS_TABLE_DATA';